import * as fromLoginPage from './login-page';
import { ActionReducerMap } from '@ngrx/store';
export const AUTH_FEATURE_KEY = 'auth';

export interface AuthState {
    [fromLoginPage.LOGIN_PAGE_FEATURE_KEY]: fromLoginPage.State;
}

export interface AuthPartialState {
    readonly [AUTH_FEATURE_KEY]: AuthState;
}

export const reducers: ActionReducerMap<AuthState> = {
    [fromLoginPage.LOGIN_PAGE_FEATURE_KEY]: fromLoginPage.reducer,
};
